import { RafflePrimaryInfoVisitor } from "@components/raffles/visitor/primaryInfo";
import { RaffleResultVisitor } from "@components/raffles/visitor/result";
import { RaffleRewardVisitor } from "@components/raffles/visitor/reward";
import { RaffleSummaryVisitor } from "@components/raffles/visitor/summary";
import { RaffleTicketVisitor } from "@components/raffles/visitor/tickets";
import { IRaffleDefaultDTO } from "@hooks/dtos/raffles/IRaffleDefaultDTO";
import {
  saveCampaignAffiliateReferral,
  savePlatformAffiliateReferral,
} from "@hooks/functions/Referral/storage";
import { ZuToastifyStore } from "@hooks/stores/zustand-toastify-store";
import { api } from "@service/api";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import "./DefaultRaffleVisit.css";

export function DefaultRaffleVisit() {
  const {
    actions: { pushToastify },
  } = ZuToastifyStore();

  const [searchParams, setSearchParams] = useSearchParams();
  const key = searchParams.get("key");
  const aff = searchParams.get("aff");
  const campaign = searchParams.get("campaign");

  const [raffle, setRaffle] = useState<IRaffleDefaultDTO>();
  const raffleKey = key || raffle?.key;

  const handleCampaignInfo = async () => {
    try {
      const search = new URLSearchParams();
      if (key) search.append("key", key);
      else if (campaign) search.append("campaign", campaign);

      const params = `?${search.toString()}`;
      const result = await api.get(`/raffle/primaryInfo${params}`);
      
      if (!key && result.data?.key) {
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.set("key", result.data.key);
        setSearchParams(nextSearchParams, { replace: true });
      }

      setRaffle(result.data);
    } catch (err: any) {
      console.error(err);
      pushToastify({
        message: err?.message || "Erro ao encontrar informações da Campanha.",
        type: "error",
        theme: "dark",
        pauseOnHover: true,
      });
    }
  };

  const getReferralParams = () => ({
    key: raffleKey,
    campaign,
    atsign: aff,
  });

  const handlePlatformReferral = async () => {
    if (!aff || !raffleKey) return;

    try {
      const result = await api.get(`/raffleClient/referral/platform`, {
        params: getReferralParams(),
      });

      if (result?.data?.affiliateId) {
        savePlatformAffiliateReferral(result.data);
      }
    } catch (err: any) {
      console.error(err);
      pushToastify({
        message: err?.message || "Erro ao encontrar informacoes de indicacao.",
        type: "error",
        theme: "dark",
        pauseOnHover: true,
      });
    }
  };

  const handleCampaignReferral = async () => {
    if (!aff || !raffleKey) return;

    try {
      const result = await api.get(`/raffleClient/referral/campaign`, {
        params: getReferralParams(),
      });

      if (result?.data?.campaignKey) {
        saveCampaignAffiliateReferral(result.data);
      }
    } catch (err: any) {
      console.error(err);
      pushToastify({
        message: err?.message || "Erro ao encontrar informações de afiliação.",
        type: "error",
        theme: "dark",
        pauseOnHover: true,
      });
    }
  };

  useEffect(() => {
    handlePlatformReferral();
    handleCampaignReferral();
  }, [raffleKey, campaign, aff]);

  useEffect(() => {
    handleCampaignInfo();
  }, []);

  return (
    <>
      <section
        className="bg-light pt-5 pb-4 px-3"
        style={{
          background:
            "linear-gradient(160deg, #fff 0%, #ECF4FF 60%, #D6E9FF 100%)",
          overflow: "hidden",
        }}
      >
        <div className="container px-3 px-md-4 px-lg-0 visit-campaign-page">
          {raffle && <RaffleSummaryVisitor raffle={raffle} />}

          {raffle && raffleKey && (
            <RaffleTicketVisitor raffle={raffle} raffleKey={raffleKey} />
          )}

          {raffle && <RafflePrimaryInfoVisitor raffle={raffle} />}

          {raffleKey && (
            <RaffleRewardVisitor
              raffleKey={raffleKey}
              campaign={campaign || ""}
            />
          )}
          {raffleKey && <RaffleResultVisitor raffleKey={raffleKey} />}
        </div>
      </section>
    </>
  );
}
